// src/components/course/CourseDetailHeader.js
import React from "react";
import { MapPin } from "lucide-react";

function CourseDetailHeader({
  name,
  distance,
  startLocation,
  type,
  ratingAvg,
  showPublicBtn = false,
  showUseBtn = true,
  onTogglePublic,
  onUseCourse,
  onWriteReview,
  useButtonText = "코스 사용하기",
}) {
  const PRIMARY_COLOR = "rgb(0, 224, 198)";

  return (
    <div className="bg-white p-6 rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
      {/* 1. 타이틀 및 별점 */}
      <div className="flex justify-between items-start mb-2">
        <h2 className="text-2xl font-bold text-gray-900 leading-tight">
          {name}
        </h2>
        {ratingAvg > 0 && (
          <div className="flex items-center gap-1 bg-yellow-50 px-2 py-1 rounded-lg border border-yellow-100 shrink-0">
            <span className="text-sm">⭐</span>
            <span className="text-sm font-bold text-yellow-600">
              {Number(ratingAvg).toFixed(1)}
            </span>
          </div>
        )}
      </div>

      {/* 2. 위치 및 정보 태그 */}
      <div className="flex items-center gap-1 text-gray-500 text-sm mb-4">
        <MapPin className="w-4 h-4" />
        <span>{startLocation}</span>
      </div>

      <div className="flex gap-2 mb-6">
        <span className="px-3 py-1 bg-blue-50 text-blue-500 text-xs font-bold rounded-full">
          {distance}km
        </span>
        <span className="px-3 py-1 bg-purple-50 text-purple-500 text-xs font-bold rounded-full">
          {type === "RUNNING" ? "러닝" : "산책"}
        </span>
      </div>

      {/* 3. 액션 버튼 영역 */}
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {/* 공개전환 (보조 버튼) */}
          {showPublicBtn && (
            <button
              type="button"
              onClick={onTogglePublic}
              className="flex-1 py-3 rounded-xl font-bold text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
            >
              공개전환
            </button>
          )}

          {/* 사용하기 (메인 버튼 - 민트색) */}
          {showUseBtn && (
            <button
              type="button"
              onClick={onUseCourse}
              className="flex-1 py-3 rounded-xl font-bold text-sm text-white shadow-md hover:opacity-90 transition-all active:scale-[0.98]"
              style={{ backgroundColor: PRIMARY_COLOR }}
            >
              {useButtonText}
            </button>
          )}
        </div>

        {/* 후기 작성 (테두리 버튼) */}
        <button
          type="button"
          onClick={onWriteReview}
          className="w-full py-3 rounded-xl font-bold text-sm border-2 text-gray-600 hover:bg-gray-50 transition-colors"
          style={{ borderColor: "#eee" }}
        >
          후기 작성
        </button>
      </div>
    </div>
  );
}

export default CourseDetailHeader;
